(() => {
  const gateway = document.querySelector('[data-edge-access-gateway]');
  if (!gateway) return;

  const tabs = [...gateway.querySelectorAll('[data-edge-tab]')];
  const panes = [...gateway.querySelectorAll('[data-edge-pane]')];

  const showPane = (name) => {
    tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.edgeTab === name)));
    panes.forEach((pane) => pane.classList.toggle('is-active', pane.dataset.edgePane === name));
  };

  tabs.forEach((tab) => tab.addEventListener('click', () => showPane(tab.dataset.edgeTab)));

  const requestedPane = new URLSearchParams(window.location.search).get('access');
  if (requestedPane === 'request' || window.location.hash === '#request-access') {
    showPane('request');
  } else if (requestedPane === 'login' || window.location.hash === '#client-login') {
    showPane('login');
  } else {
    showPane(gateway.dataset.edgeDefaultPane || 'login');
  }

  tabs.forEach((tab) => tab.addEventListener('click', () => {
    const nextHash = tab.dataset.edgeTab === 'request' ? '#request-access' : '#client-login';
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${nextHash}`);
  }));

})();
